/**
 * Clientvalidatie voor de auth-formulieren: alleen voor snelle, begrijpelijke
 * feedback. De server valideert altijd opnieuw.
 */
export type FieldErrors = Partial<Record<'name' | 'email' | 'password', string>>;

export function validateAuthForm(
  values: { name?: string; email: string; password: string },
  mode: 'login' | 'register',
): FieldErrors {
  const errors: FieldErrors = {};
  if (mode === 'register' && !values.name?.trim()) errors.name = 'Vul je naam in.';
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email.trim())) {
    errors.email = 'Vul een geldig e-mailadres in, bijvoorbeeld naam@club.nl.';
  }
  if (!values.password) errors.password = 'Vul je wachtwoord in.';
  else if (mode === 'register' && values.password.length < 10) {
    errors.password = 'Gebruik minimaal 10 tekens.';
  }
  return errors;
}
